import api from "./core";

const config = require("./serverCfg").default;

const basePath = "api/core/ChatUserPortalUser";

export default {
  create(data) {
    return api.put(`${basePath}`, data, {
      "Hide-Loading": true
    });
  },
  getAll(id) {
    return api.get(`${basePath}/${id}`, {
      "Hide-Loading": true
    });
  },
  find(id) {
    return api.get(`${basePath}/FindById/${id}`, {
      "Hide-Loading": true
    });
  },
  update(id) {
    return api.patch(
      `${basePath}/${id}`,
      {},
      {
        "Hide-Loading": true
      }
    );
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`, {
      "Hide-Loading": true
    });
  },
  hasUnSeenMessages(id) {
    return api.get(`${basePath}/HasUnSeenMessages/${id}`, {
      "Hide-Loading": true
    });
  },
  sendToPortal(data, signalRAppUrl) {
    return fetch(
      `${signalRAppUrl}/api/signalr/chat/SendNewMessageSignalToPortalApp/${data.tenantName}`,
      {
        body: JSON.stringify(data.receivers),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${config.token}`
        }
      }
    );
  }
};
